module.exports = __webpack_public_path__ + "img/m-mycb02.cb3df506.png";